import { defineMessages } from 'react-intl-next';

export default defineMessages({
	notificationsIndicatorLabel: {
		id: 'dev-agents.app.notifications.indicator-label',
		defaultMessage: 'Notifications indicator',
		description: 'Label for the notifications indicator button in the top navigation',
	},
});
